export const roundNumber = (value: number): number => {
  const numberValue = Number(value);
  return Math.round(numberValue * 2) / 2;
};

export const formatNumber = (value: number): string => {
  return roundNumber(value).toLocaleString('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  });
};
export const parseNumberAndFormat = (value: string): string => {
  const normalize = value.replace(',', '.');
  const number = Number(normalize);
  if (!Number.isFinite(number)) {
    return value;
  }
  return formatNumber(number);
};
